import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';

const renderField = ({
  input, placeholder, type, meta: { touched, error },
}) => (
  <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
    <input {...input} placeholder={placeholder} type={type} />
    {touched && error && <span className="form__form-group-error">{error}</span>}
  </div>
);

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
};

class SystemReview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      load: false
    };
  };
  /*
   componentDidMount() {
     this.setState({ load: true }, ()=>{
       this.props.loadSystemReview().then((load) => {
         this.setState({ load: load },()=>{
             console.log("cargar revisión del sistema !!");
         });
       }).catch((error)=>{
         console.log(error)
       });
     })
     
   }*/ 
   componentDidMount(){
     console.log(this.props);
   }

  render() {

    return (<Col>
      <div style={{ marginTop: 10, marginBottom: 20 }}>
        <h5>Revisión del sistema</h5>
      </div>
      <div className="form">
        {this.props.ailments.map((ailment, index) => {
          return (<div key={index} className="form__form-group" style={{ width: '100%', marginRight: 20, display: 'flex' }}>
            <span className="form__form-group-label" style={{ marginRight: 10, width: 150 }}>{ailment.ailment}</span>
            <div className="form__form-group-field">

              <textarea
                key={`comment-${ailment.ailment}`}
                name={`comment-${ailment.ailment}`}
                defaultValue={ailment.commentary}
                onChange={(e) => { this.props.handlerCommentsSystemReview(e.target.value, index) }}
              >
              </textarea>
            </div>
          </div>)
        })}
      </div>
    </Col>)
  }
}

export default reduxForm({
  form: `system-review-form`, // a unique identifier for this form
})(withTranslation('common')(SystemReview));